// react library imports
import {useState, useRef, useEffect} from 'react';
import { CaretDown, CaretUp, X} from 'phosphor-react';

// style imports
import '../Input/Input.css';
import '../SelectField/SelectField.css';
import './MultiSelect.css';

// main component imports
import { LoadingAnimation } from 'Component';
import NameWrapper from 'Hoc/NameWrapper';

const MultiSelect = ({isLoading, list, isError, keyName, label, value, onChange, id}) => {
    // set state for show list container
    const [show, setShow] = useState(false)
    const focus = value?.length > 0
    const listOfValue = list?.filter(item=>value?.includes(item?.id))

    // Ref to track the select container element
    const selectRef = useRef(null);

    // Close dropdown when clicking outside of the component
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (selectRef.current && !selectRef.current.contains(event.target)) {
                setShow(false); // Close dropdown when clicking outside
            }
        };

        // Add event listener to detect clicks outside
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up the event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // handle onchange event
    const handleOnchange = (e) =>{
        if (onChange) {     
            const isPresent = value?.some(item=>item===e?.id)
            let newValue = []
            if (isPresent) {
                newValue = value
            }else{
                newValue = [...value, e?.id]
            }
            onChange(newValue)
        }

    }

    // list of option component
    const ListOfOption = () =>{
        if (isLoading) return <div className='select_option_container mues_row_center'><LoadingAnimation/></div>
        if (isError) return <div className='select_option_container mues_row_center'>
            <h6 className='mues_red mues_font_weight_500'>Something went wrong! please try to refresh page</h6>
        </div>
        if (list?.length <= 0) return <div className='select_option_container mues_row_center'>
            <h6 className='mues_grey_II mues_font_weight_500'>No Data Found</h6>
        </div>
        return(
            <div className='select_option_container'>
                {list?.map(item=>(
                    <div key={item.id}>
                        {keyName && <p className='select_option_card mues_grey_I 
                        mues_font_weight_600' onClick={()=>handleOnchange(item)}><NameWrapper className={'large_name_wrapper'}>{item[keyName]}</NameWrapper></p>}
                        {!keyName && <p className='select_option_card mues_grey_I 
                        mues_font_weight_600' onClick={()=>handleOnchange(item)}><NameWrapper className={'medium_name_wrapper'}>{item.user?.first_name} {item.user?.last_name}</NameWrapper></p>}
                    </div>
                ))}
            </div>
        )
    }

    // handle remove item from value
    const handleRemoveValue = (e) =>{
        if (onChange) { 
            const newValue = value?.filter(item=>item!==e.id)
            onChange(newValue)
        }
    }

    // value card component
    const ValueCard = ({item})=>{
        return(
            <div className='value_card_container' onClick={()=>handleRemoveValue(item)}>
                {keyName ? <p className='mues_grey_I mues_font_weight_500'><NameWrapper className={'extra_small_name_wrapper'}>
                {item[keyName]}</NameWrapper></p>:<p className='mues_grey_I
                mues_font_weight_500'><NameWrapper className={'medium_name_wrapper'}>
                {item.user?.first_name} {item.user?.last_name}</NameWrapper></p>}
                <X className='mues_red mues_icon_wrapper' weight='bold'/>
            </div>
        )
    }
  return (
    <div className={`form-input select_field_container 
    ${show && 'active_selected_field'}`} onClick={()=>setShow(!show)} id={id} ref={selectRef}>
        <div className='mues_row_space_between tags_scroll'>
            <div className='mues_row_flex mues_column_gap_8'>
                {listOfValue?.map(item=>(
                    <ValueCard item={item} key={item.id}/>
                ))}
            </div>
            {show ? <CaretUp className='edit_label mues_pointer' 
            weight='fill'/>:<CaretDown className='edit_label mues_pointer' weight='fill'/>}
        </div>
        <label className={focus ? 'form_focus':''}>{label}</label>
        {show && <ListOfOption/>}
    </div>
  )
}

export default MultiSelect